import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next/pages';
import { useFavouriteHotels } from 'hooks/useFavouriteHotels';
import { findKeyByRewriteUrl } from 'urlTranslations';
import { FAVOURITES_PATH } from 'utils/favouriteHotels';

// WHIT-485 round 3: the header's way to the favourite hotels, with how many
// there are — the incumbent's floating "Kedvenc szállások" counter.

// `className` sets the display (inline-flex, at which widths): the header
// shows one link on phones and another on wide screens, and a display set here
// as well would override its `hidden`.
const FavouritesLink: React.FC<{ className?: string }> = ({
  className = '',
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { hotels } = useFavouriteHotels();
  const count = hotels?.length || 0;
  const label = count
    ? t('Favourite hotels ({{count}})', { count })
    : t('Favourite hotels');

  return (
    <Link
      href={findKeyByRewriteUrl(FAVOURITES_PATH, router.locale)}
      aria-label={label}
      title={label}
      className={`relative h-9 w-9 items-center justify-center rounded-full text-2xl leading-none text-tt-dark-purple hover:bg-tt-light-gray ${className}`}
    >
      <span aria-hidden="true">♡</span>
      {count > 0 && (
        <span
          aria-hidden="true"
          className="absolute -right-1 -top-1 min-w-[1.25rem] rounded-full bg-tt-dark-purple px-1 text-center text-xs font-semibold leading-5 text-white"
        >
          {count}
        </span>
      )}
    </Link>
  );
};

export default FavouritesLink;
